export const _openLinkBlank = (href, target = '_blank') => {
    if (!href) return;

    if (/^mailto:/.test(href)) {
        window.location.href = href;
    } else {
        window.open(href, target);
    }
};
